/* global window document localStorage */

// JS imports
import $ from 'jquery';
import Vue from 'vue';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import throttle from 'lodash/throttle';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import en from 'vee-validate/dist/locale/en';
import da from 'vee-validate/dist/locale/da';
import VueBgSrc from 'vue-bg-src';
import VueYouTubeEmbed from 'vue-youtube-embed';
import SkyReveal from 'sky-reveal';
import VueScrollTo from 'vue-scrollto';
import Multiselect from 'vue-multiselect';
import AOS from 'aos';

import { i18n } from '../translation.js';
import './svgs';
import { RestComponent } from './mixins/rest-component';

//<--plop-vue-components-->//
import './MemberResignForm';
import './ContactFilterOverview';
import './HighligtedResultsFilterOverview';
import './ThumbnailCardFilterOverview';
import './AvatarCardFilterOverview';
import './EventsGrid';
import './EventsBoxResults';
import './CategoryShowMore';
import './NestedCategoryFilters';
import './TestContact';
import './TestStudy';
import './TestJobs';
import './TestAssociations';
import './TestArticles';
import './TestInhabitants';
import './TestHeader';
import './TestSelect';
import './TestResult';
import './TestPromo';
import './IconSelector';
import './PressItemSimple';
import './LoadingLabel';
import './CheckoutAutoComplete';
import './Search';
import './ContactForm';
import './StickyContact';
import './PressItem';
import './FilterContent';
import './TaxonomyFilters';
import './NewsletterSignupTransmitter';
import './Popup';
import './PopupNewsletter';
import './MemberSignupForm';
import './CategoryFilter';
import './GridArticles';
import './UploadButton';
import './ExperienceBar';
import './ResumeItem';
import './ResumeList';
import './OverviewFilter';
import './ResumeFilter';
import './CategorySelector';
import './JobList';
import './FilterOverviewItem';
import './FilterOverview';
import './QdAddToGoogleCalendar';
import './QdAddToCalendar';
import './QdShare';
import './QdCheckbox';
import './SelectPill';
import './QdRadioButton';
import './TabContent';
import './TabsContent';
import './QdAccordion';
import './QdMultiSelect';
import './Loading';
import './Events';
import './NewsletterSignup';
import './YoutubeVideo';
import './Graph';
import './CircleGraph';
import './VariationRadioButton';
import './SlideInOverlay';
import './SlideInOverlayFooter';
import './SlideInCloseBtn';
import './SlideInBackBtn';
import './CenterSlider';
import './ArticleCard';
import './ArticleCardDetailed';
import './ArticleSlider';
import './Tag';
import './GuidesSlider';
import './ImageSlider';

// Initialize siteData variable on window
window.siteData = window.siteData || {};

// Add site-wide data here:
const siteData = Object.assign(window.siteData, {
	showNav: false,
	isMounted: false,
	scrollPosition: 0,
	targetCategories: [],
	popup: '',
	acceptTerms: false,
	newsletterSignupData: null,
	menuHovered: null,
	menuHoveredHasChildren: false,
	overlayCloseBarTransparent: true,
	isContactFormOpen: false,
	showSignupSlideIn: false,
	scrollbarWidth: '',
	isIE: null,
});

// Set locale
i18n.locale = siteData.language;

siteData.langClass = 'lang-' + siteData.language;
moment.locale(siteData.language);

// Install the Plugin and set the locale.
Vue.use(VeeValidate, {
	i18n,
	dictionary: {
		en: en,
		da: da,
	},
});

Vue.use(VueBgSrc, {
	mediaQueries: {
		md: '(min-width: 350px)',
		lg: '(min-width: 736px)',
		xl: '(min-width: 1000px)',
	},
});

Vue.use(VueScrollTo, {
	duration: 500,
	easing: 'ease-in-out',
	offset: -50,
});

Vue.use(VueYouTubeEmbed);
Vue.use(SkyReveal);
Vue.component('multiselect', Multiselect);

Vue.directive('scroll-inside', {
	inserted: function (el, binding) {
		let f = throttle(function (evt) {
			if (binding.value(evt, el)) {
				el.removeEventListener('scroll', f);
			}
		}, 50);
		el.addEventListener('scroll', f);
	},
});

Vue.directive('scroll', {
	inserted: function (el, binding) {
		let f = throttle(function (evt) {
			if (binding.value(evt, el)) {
				window.removeEventListener('scroll', f);
			}
		}, 200);
		window.addEventListener('scroll', f);
	},
});

export default new Vue({
	el: '#root',
	mixins: [RestComponent],
	data: siteData,
	computed: {
		isHeaderNeg: (vm) => {
			return vm.menuHoveredHasChildren && vm.isNegTemplate;
		},
		isNegTemplate: (vm) => {
			const templates = [
				'single-member.php',
				'single-education.php',
				'single-product.php',
				'single-employee.php',
				'template-homepage.php',
				'template-sub-homepage.php',
				'template-categories-overview-v2.php',
			];

			return templates.filter((item) => item === vm.currentTemplate).length > 0;
		},
		showOverlay: (vm) =>
			vm.showNav ||
			vm.popup === 'newsletter-signup-agreements' ||
			vm.popup === 'member-signup' ||
			vm.menuHoveredHasChildren,
		lAppClasses: (vm) => {
			const dynamicClasses = {
				'l-app--overlay': vm.showNav,
			};

			return ['l-app', dynamicClasses];
		},
		lAppMenuClasses: (vm) => {
			const dynamicClasses = {
				'l-app__menu--show': vm.showNav,
			};

			return dynamicClasses;
		},
		lAppSidebarClasses: (vm) => {
			const dynamicClasses = {
				'l-app__sidebar--fixed': vm.showNav,
				'l-app__sidebar--border-bottom-until-lg': vm.showNav,
				'l-app__sidebar--bg-white': vm.showNav || vm.hasIsSidebarWhite,
				'l-app__sidebar--white-line':
					vm.isNegTemplate && !vm.showNav && !vm.isHeaderNeg,
				'l-app__sidebar--full-width-until-lg': vm.showNav,
			};

			return ['l-app__sidebar', dynamicClasses];
		},
		sidebarClasses: (vm) => {
			const dynamicClasses = {
				'sidebar--white': vm.isNegTemplate && !vm.showNav && !vm.isHeaderNeg,
			};

			return ['sidebar', dynamicClasses];
		},
		burgerDotsClasses: (vm) => {
			const dynamicClasses = {
				'o-burger__dots--close': vm.showNav,
			};

			return ['o-burger__dots', dynamicClasses];
		},
		hasIsSidebarWhite: (vm) => get(vm, 'isSidebarWhite', false),
	},
	watch: {
		/* showOverlay() {
			if (this.showOverlay) {
				this.setScrollPosition();
			} else {
				this.removeScrollPosition();
			}
		}, */
		popup() {
			if (this.popup !== '') {
				this.setScrollPosition();
			} else {
				this.removeScrollPosition();
			}
		},
		showNav() {
			if (this.showNav) {
				this.setScrollPosition();
			} else {
				this.removeScrollPosition();
			}
		},
		isContactFormOpen() {
			if (this.isContactFormOpen) {
				this.setScrollPosition();
			} else {
				this.removeScrollPosition();
			}
		},
		showSignupSlideIn() {
			if (this.showSignupSlideIn) {
				this.setScrollPosition();
			} else {
				this.removeScrollPosition();
			}
		},
		menuHovered() {
			this.$nextTick(() => {
				// Set sidebar and header variable
				const sidebar = $('.l-app__sidebar');
				const header = $('.l-app__header');

				// Check if menu is active and do according actions
				if (this.menuHoveredHasChildren) {
					// Make sidebar and header go over overlay and change line from sidebar to megadropdown
					sidebar
						.addClass('l-app__sidebar--important l-app__sidebar--no-border')
						.removeClass('l-app__sidebar--bg-white');
					header.addClass(
						'l-app__header--important l-app__header--mega-dropdown-has-line'
					);
				} else {
					this.$nextTick(() => {
						// Change line back from megadropdown to sidebar
						sidebar
							.removeClass('l-app__sidebar--no-border')
							.addClass('l-app__sidebar--important');
						if (this.hasIsSidebarWhite)
							sidebar.addClass('l-app__sidebar--bg-white');

						header.removeClass('l-app__header--mega-dropdown-has-line');

						// Set remove --important classes after short delay so header and sidebar stay above l-app__overlay
						setTimeout(() => {
							header.removeClass('l-app__header--important');
							sidebar.removeClass('l-app__sidebar--important');
						}, 300);
					});
				}
			});
		},
	},
	methods: {
		goto(refName) {
			var element = this.$refs[refName];
			element.scrollIntoView({ behavior: 'smooth' });
		},
		setScrollPosition() {
			siteData.scrollPosition = window.pageYOffset;
			$('html').css('top', `-${siteData.scrollPosition}px`);
			$('html').addClass('no-scroll');
		},
		removeScrollPosition() {
			$('html').removeClass('no-scroll');
			window.scrollTo(0, siteData.scrollPosition);
			siteData.scrollPosition = 0;
		},
		updateData(name, value) {
			if (process.env.NODE_ENV !== 'production') {
				console.log(name, value);
			}
			siteData[name] = value;
		},
		submittingForm() {
			const button = document.getElementById('submitbutton');
			button.disabled = true;
			const loader = document.getElementById('submitloader');
			loader.classList.add('submitting-loader__visible');
		},
		overlayClicked() {
			if (siteData.showNav) this.hideNav();
			if (siteData.popup !== '') this.resetPopup();
		},
		resetPopup() {
			this.popup = '';
		},
		hideNav() {
			this.$nextTick(() => {
				siteData.showNav = false;
			});
		},
		toggleNav() {
			siteData.showNav = !siteData.showNav;
		},
		isLessThanThreeMonthsOld(date) {
			return moment(date).isAfter(moment().subtract(3, 'months'));
		},
		cleanUpCategories(array) {
			return array.filter(
				(item) => !this.isLessThanThreeMonthsOld(get(item, 'timestamp', ''))
			);
		},
		getTargetCategories(localStorageKey) {
			if (storageAvailable('localStorage')) {
				const storageItem = JSON.parse(localStorage.getItem(localStorageKey));
				const categories = Array.isArray(storageItem)
					? this.cleanUpCategories(storageItem)
					: [];
				return categories;
			}
		},
		occursInArray(array = [], key, value) {
			return array.reduce(function (n, object) {
				return n + (object[key] === value);
			}, 0);
		},
		getSelectedTargetCategories(localStorageKey, occurrences = 9) {
			const categories = this.getTargetCategories(localStorageKey);
			const selectedCategories = categories.filter(
				(item) => this.occursInArray(categories, 'id', item.id) > occurrences
			);
			return uniqBy(selectedCategories, 'id');
		},
		setTargetCategories(
			localStorageKey = 'targetCategories',
			newCategories = []
		) {
			if (newCategories.length > 0) {
				if (storageAvailable('localStorage')) {
					const storageCategories = this.getTargetCategories(localStorageKey);
					const formatedNewCategories = newCategories.map((item) => ({
						id: item,
						timestamp: moment().unix(),
					}));
					const concatedCategories = JSON.stringify([
						...formatedNewCategories,
						...storageCategories,
					]);
					localStorage.setItem(localStorageKey, concatedCategories);
				}
			}
		},
		showDropdown(id) {
			return this.menuHovered === id;
		},
		toogleSearchCloseTransparency() {
			if (this.$el.clientWidth < 1000) {
				const el = $('.js-search-overlay');
				this.overlayCloseBarTransparent = el.scrollTop() > 50 ? false : true;
			}
		},
		setMenuHovered(value, hasChildren = false) {
			window.clearTimeout(this.$options.MenuHoveredTimeOut);
			this.$options.MenuHoveredTimeOut = window.setTimeout(() => {
				this.menuHovered = value;
				this.menuHoveredHasChildren = hasChildren;
			}, 250);
		},
		resetMenuHovered() {
			window.clearTimeout(this.$options.MenuHoveredTimeOut);
			this.$options.MenuHoveredTimeOut = window.setTimeout(() => {
				this.menuHovered = null;
				this.menuHoveredHasChildren = false;
			}, 300);
		},
		getScrollbarWidth() {
			return window.innerWidth - document.documentElement.clientWidth + 'px';
		},
		istargetCategoriesStudent() {
			if (this.targetCategories === '') return false;

			const firstMatch = get(this.targetCategories.split(','), '0', -1);
			const firstMatchAsInt = parseInt(firstMatch);

			return firstMatchAsInt === 167 || firstMatchAsInt === 179;
		},
		detectIE() {
			const ua = window.navigator.userAgent;

			const msie = ua.indexOf('MSIE ');
			if (msie > 0) {
				// IE 10 or older => return version number
				return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
			}

			const trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				const rv = ua.indexOf('rv:');
				return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
			}

			// other browser
			return false;
		},
	},
	created() {
		siteData.isIE = this.detectIE();
		AOS.init({
			duration: 600,
			easing: 'ease-out-quart',
			once: process.env.NODE_ENV === 'production',
		});
	},
	beforeMount() {
		this.scrollbarWidth = this.getScrollbarWidth();
		this.setTargetCategories('targetCategories', this.currentTargetCategories);
		this.targetCategories = this.getSelectedTargetCategories(
			'targetCategories',
			5
		)
			.map((item) => item.id)
			.join(',');

		const urlVars = this.getUrlVars();
		this.popup = get(urlVars, 'search_str', '') !== '' ? 'search' : '';
	},
	i18n: i18n,
});

function storageAvailable(type) {
	var storage;
	try {
		storage = window[type];
		var x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return (
			e instanceof DOMException &&
			// everything except Firefox
			(e.code === 22 ||
				// Firefox
				e.code === 1014 ||
				// test name field too, because code might not be present
				// everything except Firefox
				e.name === 'QuotaExceededError' ||
				// Firefox
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
			// acknowledge QuotaExceededError only if there's something already stored
			storage &&
			storage.length !== 0
		);
	}
}
